import { post, get } from '@/utils/network';
export default new class StudentHomeApi {
    // 【会员状态】获取自己当前是不是会员卡，并且会员的时间期间
    getMyVipCardValid() {
        return post('Paycourse/VipCard/getMyVipCardValid')
    }
    // 【【会员卡】获取可以购买的会员卡列表
    getVipCardList(params: { type : number }) {
    return post('Paycourse/VipCard/getList',params)
    }
    //获取最低售价的价格卡
    getMinPriceVipCard() {
        return post('Paycourse/VipCard/getMinPriceVipCard')
    }
    // 【首页banner】获取banner数据
    getBannerList() {
        return post('Paycourse/Course/getBanner')
    }
    //[首页] 展示分类
    getHomeCourseList(params: { source : string }) {
        return post('Paycourse/course/index',params)
    }
    //[首页] 成长计划
    getGrowthPlanList(params: { source : string }) {
        return post('Paycourse/course/planIndex',params)
    }
    //[首页] 即将上新
    getShelfSoon(params: { source : string ,offset:string}) {
        return post('Paycourse/course/shelfSoon',params)
    }
     // 【订单】获取我的订单
     getOrderLists() {
        return post('Paycourse/Order/getLists')
    }
     // 【订单】获取订单详细信息
     getOrderInfo(params: { orderNo: string }) {
        return post('Paycourse/Order/getOrderInfo',params)
    }
     // 【订单】查询某个订单的支付状态
     getQueryOrder(params: { orderNo: string }) {
        return post('Paycourse/Order/queryOrder',params)
    }
      // 【订单】用户进行下单操作，生成支付信息
    createOrder(params: { product_source: string,product_id: string,openid: string }) {
        return post('Paycourse/Order/createOrder',params)
    }
    //【课程】获取课程详情
    getCourseDetails(params: { courseid: string,categoryid?:string}) {
        return post('Paycourse/Course/getCourseDetails',params)
    }
    //【课程】获取正在学习的课
    getProgress(params: { study_status: string,page: number,limit: number}) {
        return post('Paycourse/Course/getProgress',params)
    }
     //【课程】获取正在学习的课链接
     getLearningAddress(params: { courseid: string}) {
        return post('Paycourse/Course/getLearningAddress',params)
    }
    
    //获取三节课分类列表
    getCategoryLists(params: { source : string }) {
        return post('Paycourse/course/categoryLists',params)
    }
    //根据分类获取课程
    getcategoryCourse(params: { source : string ,page: number,page_size : number,name:string, pid : string,id : string}) {
        return post('Paycourse/course/categoryCourse',params)
    }
    //获取全部成长计划
    getPlanList(params: { source : string }) {
        return post('Paycourse/course/planLists',params)
    }
    //获取成长计划详情
    getPlanDetai(params: { source : string,id:string,tag_id:string }) {
        return post('Paycourse/course/planDetail',params)
    }
    //埋点日志
    trackLog(params: { type : number,event_id:string,user_agent?:string, from_url?:string, residence_time?:number}) {
        if( params['user_agent'] == "" || params['user_agent'] == null){
            params['user_agent'] = navigator.userAgent;
        }
        if( params['from_url'] == "" || params['from_url'] == null){
            params['from_url'] = document.referrer;
        }
        return post('Paycourse/Tracking/track',params)
    }
}